<template>
  <div class="about">

    <!-- Header Area Start -->
    <AppHeader></AppHeader>


    <!-- Contents Area Start -->
    <div class="contents">

      <h2>About Me</h2>

      <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</p>

      <p>At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</p>

      <ul class="infor">
        <li>
          <i class="xi-user-o"></i> 
          <strong>Name :</strong> Riley Johnson
        </li>
        <li>
          <i class="xi-calendar"></i> 
          <strong>Date of Birth :</strong> 1920. 2. 1
        </li>
        <li>
          <i class="xi-compass-o"></i> 
          <strong>Address :</strong> Los Angeles, USA
        </li>
        <li>
          <i class="xi-mail-o"></i> 
          <strong>Email :</strong> Riley@naver.com
        </li>
        <li>
          <i class="xi-call"></i> 
          <strong>Phone :</strong> 01-123-9906
        </li>
        <li>
          <i class="xi-laptop"></i> 
          <strong>Freelance :</strong> Available
        </li>
      </ul> 

      <div class="divider"></div>

      <div class="skills">
        <h3>Skills</h3>
        <ul class="progress-group">
          <li>
            <h4>HTML5 <span>85%</span></h4>
             <div class="progress">
                <div class="determinate" style="width: 85%"></div>
            </div>
          </li>
          <li>
            <h4>CSS3 <span>88%</span></h4>
             <div class="progress">
                  <div class="determinate" style="width: 88%"></div>
              </div>
          </li>
          <li>
            <h4>JAVASCRIPT <span>70%</span></h4>
             <div class="progress">
                <div class="determinate" style="width: 70%"></div>
            </div>
          </li>
          <li>
            <h4>JQUERY <span>80%</span></h4>
             <div class="progress">
                <div class="determinate" style="width: 80%"></div>
            </div>
          </li>
        </ul>
      </div>

    </div>    


    <!-- Footer Area Start -->
    <AppFooter></AppFooter>

  </div>
</template>

<script>
import AppHeader from './component/Header.vue';
import AppFooter from './component/Footer.vue';


export default {
  name: "About",
  components: {
    AppHeader,
    AppFooter
  },
  mounted() {
    this.progressAni();
    this.menuAct2();
  },
  methods: {

    progressAni(){

      // 1. 컨트롤러 생성
      var controller = new ScrollMagic.Controller();

      // 2. 애니메이션 설정
      var bar1 = $('.skills li:nth-child(1) .determinate');
      var bar2 = $('.skills li:nth-child(2) .determinate');
      var bar3 = $('.skills li:nth-child(3) .determinate');
      var bar4 = $('.skills li:nth-child(4) .determinate');
      var tl = new TimelineMax();

      tl.fromTo(bar1, 1, {width: "0%"}, {width: "85%"}, 0.5)
        .fromTo(bar2, 1, {width: "0%"}, {width: "88%"}, 1)
        .fromTo(bar3, 1, {width: "0%"}, {width: "70%"}, 1.5)
        .fromTo(bar4, 1, {width: "0%"}, {width: "80%"}, 2);


      // 3. 장면 설정
      var scene = new ScrollMagic.Scene({
        triggerElement: '.skills',
        triggerHook: 0.6
      })
      .setTween(tl)      // 4. 장면에 애니메이션 연결
      .addTo(controller); // 5. Scene을 컨트롤러 연결하기

    },

    menuAct2(){
      $('.footer a').removeClass('menu-act');
      $('.footer li:nth-child(2) a').addClass('menu-act');
    }

  }
}
</script>

<style lang="scss" scoped>
  @import '../sass/partials/_variable.scss', '../sass/partials/_mixin.scss';

  .about{

    .contents{
      padding-bottom: 148px;

      h2+p{font-weight: bold; margin-bottom: 21px;}
      h2+p+p{margin-bottom: 42px;}

      .infor li{ margin-bottom: 10px; }

      .divider{ margin: 50px 0; }

      h3{
        color: $typo2;
        @include font-set(500, 2.2rem, 30px, $ff4);
        margin-bottom: 30px;
      }

      // Progress Group
      .progress-group{
        li{
          margin-bottom: 30px;

          h4{
            height: 20px;
            @include font-set(800, 1.7rem, 20px, $ff1);
            color: $typo2;
            position: relative;

            span{
              position: absolute; right: 10px; top: 0;
            }
          }

          .progress{ background-color: $p-bg1; }
          &:nth-child(1) .determinate{background-color: $p-bg2;}
          &:nth-child(2) .determinate{background-color: $p-bg3;}
          &:nth-child(3) .determinate{background-color: $p-bg4;}
          &:nth-child(4) .determinate{background-color: $p-bg5;}
        }
      }

    }
  }

</style>


// WEBPACK FOOTER //
// src/components/About.vue